import { createAction, props } from '@ngrx/store';

import { AuthUser } from '@excelway/types/auth-user.types';

export const updateCurrentUser = createAction(
  '[Auth] Update Current User',
  props<{ user: AuthUser }>()
);
